
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { Action, Getter, State } from 's-vuex-class'
import Modal from './Modal.vue'
import BaseButton from './BaseButton.vue'
import Dropdown from './Dropdown.vue'
import { IFilter, IDigest } from '@/entities'
import FilterModalMobileHeader from '@/components/FilterModalMobileHeader.vue'

@Component<FilterBarLoader>({
    components: { FilterModalMobileHeader, Modal, BaseButton, Dropdown },
})
export default class FilterBarLoader extends Vue {
    @Action public getDigests
    @Action public patchFilter
    @Action public setFilterEditing
    @Action public setDigestEditing

    @Getter public filterActive
    @Getter public filterSets
    @Getter public digestSets?: IDigest[]
    @Getter public tsMobileView

    public get hasFilters() {
        const filterSets = Object.values(this.filterSets) as IFilter[][]

        for (let i = 0; i < filterSets.length; i++) {
            if (filterSets[i].length > 0) {
                return true
            }
        }

        return false
    }

    public getName(filter: IFilter) {
        // If there's no name, try construct one ad-hoc
        if (filter.name) {
            return filter.name
        }
        const time = `${filter.time_value} ${filter.time_unit}`
        const rules = filter.filter_rules
        const ruleString = rules
            ? rules
                  .map(({ column, value }) => `${column}: ${value.join('|')}`)
                  .join(', ')
            : ''
        return `${time} ${ruleString}`
    }

    public getDigestForFilter(filterId: number) {
        const { digestSets } = this
        if (digestSets) {
            return digestSets.find((digest) => digest.filter_id === filterId)
        }
    }

    // 'loading' a filter means patching the default filter with the values of the source filter
    public loadFilter(filter: IFilter) {
        if (!this.filterActive) {
            return
        }

        const { id, name, is_default } = this.filterActive

        this.patchFilter({ ...filter, name, id, is_default })

        if (filter.locked === true && this.tsMobileView) {
            setTimeout(
                () => ((this.$refs.dropdown as any).$data.opened = false),
                0
            )
        }
    }

    // sets the filter and its digest to editing mode
    public initEditFilter(filterId: number) {
        this.setFilterEditing({ id: filterId, mode: 'edit' })

        const digest = this.getDigestForFilter(filterId)

        if (digest) {
            this.setDigestEditing(digest.id)
        }
    }

    public initSaveFilter() {
        const active = this.filterActive
        if (active) {
            this.setFilterEditing({ id: active.id, mode: 'create' })
        }
    }
}
